import { ComponentProps, ElementType } from 'react'

import { styled } from '@motrix/tokens'

export interface BoxProps extends ComponentProps<typeof Box> {
  as?: ElementType
}

export const Box = styled('div', {})
